// src/components/StudentRootRedirect.jsx
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * When someone visits /student/:studentId,
 * redirect them to /student/:studentId/dashboard_v2.
 *
 * This is just a thin redirect helper – it renders nothing.
 */
export default function StudentRootRedirect() {
  const { studentId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (studentId) {
      navigate(`/student/${studentId}/dashboard_v2`, { replace: true });
    }
  }, [studentId, navigate]);

  return null;
}
